<template>
  <div class="coverShare" @click="shareHide()">
    <img src="@/assets/images/shareCover.png">
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  props: ['info'],
  data() {
    return {
      show: true
    }
  },
  created() {
    setTimeout(() => {
      this.shareAction()
    }, 500)
  },
  methods: {
    // 分享
    shareHide() {
      this.show = false
      this.$emit('hide')
    },
    getSignature() {
      var path = location.href.split('#')[0]
      var jsApiList = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone'
      ]
      return new Promise((resolve, reject) => {
        let _this = this
        this.$fetch('/api/WxJsSdk/GetSignature', {
          url: path,
          jsApiList: jsApiList
        })
          .then(result => {
            resolve(result)
          })
          .catch(result => {
            // reject(result)
            console.warn('获取微信签名信息失败' + result)
          })
      })
    },
    shareAction() {
      var img = require('@/assets/images/defaultImg.png')

      let _this = this

      this.getSignature().then(result => {
        wx.config({
          debug: false,
          appId: result.AppId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
          timestamp: parseInt(result.Timestamp), // 必填，生成签名的时间戳
          nonceStr: result.NonceStr, // 必填，生成签名的随机串
          signature: result.Signature, // 必填，签名，见附录1
          jsApiList: jsApiList
        })

        wx.error(function(res) {
          // _this.shareAction();
          // _this.$router.go(0);
          // alert("验证失败返回的信息:" + JSON.stringify(res));
          // logUtil.printLog("验证失败返回的信息:", res);
        })

        wx.ready(function() {
          wx.onMenuShareAppMessage({
            // 分享给朋友
            title: _this.info.title, // 分享标题
            desc: _this.info.desc, // 分享描述
            link: _this.info.link, // 分享链接 默认以当前链接
            imgUrl: _this.info.image, // 分享图标
            // 用户确认分享后执行的回调函数
            success: function() {},
            // 用户取消分享后执行的回调函数
            cancel: function() {
              console.log('分享到朋友取消')
            }
          })
          //分享到朋友圈
          wx.onMenuShareTimeline({
            title: _this.info.title, // 分享标题
            desc: _this.info.desc, // 分享描述
            link: _this.info.link, // 分享链接 默认以当前链接
            imgUrl: _this.info.image, // 分享图标
            success: function() {},
            cancel: function() {
              console.log('share cancel')
            }
          })
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.coverShare {
  width: 100%;
  position: fixed;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  left: 0px;
  top: 0px;
  z-index: 2999; // display: none;

  img {
    width: 200px;
    display: block;
    float: right;
    height: 150px;
  }
}
</style>
